/// <reference types="./right_arrow.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function right_arrow() {
  return $svg.square(
    20,
    "<path fill=\"currentColor\" d=\"M13.4766 9.16664L9.00665 4.69664L10.185 3.51831L16.6666 9.99998L10.185 16.4816L9.00665 15.3033L13.4766 10.8333H3.33331V9.16664H13.4766Z\" />",
  );
}
